import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreateCustomerAddress, UpdateCustomerAddress, DeleteCustomerAddress } from '../../services/graphql/address/index.js';
import { G as GetCustomerAddress } from '../../GetCustomerAddress--OLlOu1N.js';
import { a as privateQuery, c as privateMutate } from '../../requestsCollection-X054c_sp.js';
import { extractErrorMessage } from '../../utils/error.js';
import '../../utils/logToSlack.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-YC9H491Y.js';
import '../../utils/currency.js';
import 'react';
import '../../context/index.js';
import 'next/server';
import '../../index-Oip0gjfj.js';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import 'next/router';
import '../../helpers-kA_hdoOI.js';
import 'lodash';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../services/auth/index.js';
import '../../utils/cookies.js';
import '../../cookies-l-jEMp6P.js';
import '../../utils/isBot.js';
import '../../utils/fetchPolicyLookup.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';

const getAddresses = createAsyncThunk('account/getAddresses', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const { data, errors } = await privateQuery(apolloConfig(), {
            query: GetCustomerAddress,
            variables: payload,
        }, 'GetCustomerAddress');
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.customer.addresses;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const createAddress = createAsyncThunk('account/createAddress', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: CreateCustomerAddress,
            variables: payload,
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.createCustomerAddress;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const updateAddress = createAsyncThunk('account/updateAddress', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: UpdateCustomerAddress,
            variables: payload,
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        return data.updateCustomerAddress;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const deleteAddress = createAsyncThunk('account/deleteAddress', async (payload, { extra, rejectWithValue }) => {
    try {
        const { apolloConfig } = extra;
        const { data, errors } = await privateMutate(apolloConfig(), {
            mutation: DeleteCustomerAddress,
            variables: payload,
        });
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return rejectWithValue({
                errorMessage: errors[0].message,
            });
        }
        if (!data.deleteCustomerAddress) {
            return rejectWithValue({
                errorMessage: 'Error during deleting address',
            });
        }
        return payload.id;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});

export { createAddress, deleteAddress, getAddresses, updateAddress };
//# sourceMappingURL=thunks.js.map
